// ─── Carte d'un hub de fonctions (Core) ───────────────────────────
// Reprise fidèle de MoPCal : emoji + badge en haut, titre, description sur
// deux lignes. Une fonction verrouillée porte un 🔒 avec le palier requis, et
// s'affiche estompée. En réorganisation, la carte sélectionnée montre ◀ ▶.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI } from '../theme/PreferencesUI';
import { useT } from '../i18n/LangueContext';

const HIT = { top: 8, bottom: 8, left: 8, right: 8 };

export default function CarteHub({ tuile: m, reorg, selected, idx, total, onPress, onDeplacer }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  return (
    <TouchableOpacity style={[s.card, !m.actif && !reorg && s.cardOff, reorg && s.cardReorg, selected && s.cardSel]}
      activeOpacity={0.8} onPress={onPress}>
      <View style={s.cardTop}>
        <Text style={[s.emoji, !m.actif && s.emojiOff]}>{m.emoji}</Text>
        {!!m.badge && m.badge > 0 && (
          <View style={s.badge}><Text style={s.badgeTxt}>{m.badge > 99 ? '99+' : m.badge}</Text></View>
        )}
        {!m.actif && !selected && (
          <View style={s.soon}>
            <Text style={s.soonTxt}>🔒 {m.palier || t('famille.indisponible')}</Text>
          </View>
        )}
      </View>
      <Text style={[s.cardTitre, !m.actif && s.txtOff]} numberOfLines={2}>{m.titre}</Text>
      {!!m.desc && <Text style={s.cardDesc} numberOfLines={2}>{m.desc}</Text>}
      {selected && (
        <View style={s.moveRow}>
          <TouchableOpacity hitSlop={HIT} disabled={idx === 0} onPress={() => onDeplacer?.(-1)}
            style={[s.moveBtn, idx === 0 && s.moveBtnOff]}>
            <Text style={[s.moveTxt, idx === 0 && s.moveTxtOff]}>◀</Text>
          </TouchableOpacity>
          <TouchableOpacity hitSlop={HIT} disabled={idx === total - 1} onPress={() => onDeplacer?.(1)}
            style={[s.moveBtn, idx === total - 1 && s.moveBtnOff]}>
            <Text style={[s.moveTxt, idx === total - 1 && s.moveTxtOff]}>▶</Text>
          </TouchableOpacity>
        </View>
      )}
    </TouchableOpacity>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  card:     { width: '48.5%', backgroundColor: UI.card, borderRadius: 16, padding: 14, marginBottom: 12,
              borderWidth: 0.5, borderColor: UI.border, minHeight: 116 },
  cardOff:  { backgroundColor: UI.champ },
  cardReorg:{ borderStyle: 'dashed', borderColor: UI.accent },
  cardSel:  { borderColor: UI.accent, borderWidth: 2, backgroundColor: UI.accentTint },
  cardTop:  { flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 8 },
  emoji:    { fontSize: 24 },
  emojiOff: { opacity: 0.5 },
  cardTitre:{ fontSize: 14, fontWeight: '700', color: UI.ink, marginBottom: 3, lineHeight: 18 },
  cardDesc: { fontSize: 12, color: UI.muted, lineHeight: 15 },
  txtOff:   { color: UI.faint },
  badge:    { backgroundColor: UI.danger, borderRadius: 11, minWidth: 22, height: 22, paddingHorizontal: 6,
              alignItems: 'center', justifyContent: 'center' },
  badgeTxt: { color: '#fff', fontSize: 12, fontWeight: '800' },
  soon:     { backgroundColor: UI.accentTint, borderRadius: 8, paddingHorizontal: 8, paddingVertical: 2 },
  soonTxt:  { color: UI.accent, fontSize: 11, fontWeight: '700' },
  moveRow:  { flexDirection: 'row', justifyContent: 'space-between', marginTop: 8 },
  moveBtn:  { backgroundColor: UI.accent, borderRadius: 10, width: 46, height: 32, alignItems: 'center', justifyContent: 'center' },
  moveBtnOff:{ backgroundColor: UI.champ },
  moveTxt:  { color: '#fff', fontSize: 15, fontWeight: '800' },
  moveTxtOff:{ color: UI.faint },
});
